module.exports = __webpack_public_path__ + "media/images/icon-pin-green-f0e873a7ea44968faff7a2351fb081ae.svg";